import { ITagsSchema } from './tags-schema.interface';

export interface IAccountSchema {
    id: string;
    organizationId: string;
    externalId?: string;
    name: string;
    code: string;
    businessName: string;
    country: string;
    address?: string;
    vatNumber: string;
    email: string;
    locations?: string[];
    tags?: string[] | ITagsSchema[];
    phoneNumber?: string;
    isDeleted?: boolean;
    deletedAt?: string;
    createdAt?: string;
    updatedAt?: string;
    externalOrganizationId?: string;
}
